import { create } from 'zustand';

export type TelemetryConnectionState = 'connected' | 'connecting' | 'disconnected' | 'offline';

interface TelemetryStore {
  status: TelemetryConnectionState;
  setStatus: (status: TelemetryConnectionState) => void;
}

export const useTelemetryStore = create<TelemetryStore>((set) => ({
  status: 'connected',
  setStatus: (status) => set({ status }),
}));
